import type { Context } from "./context";


export type Handler<C extends Context = Context> = (context: C) => boolean | void | Promise<boolean | void>;
